import PropTypes from 'prop-types';
import React from 'react';
import {
    pageDisplayModePropTypes,
    userRolePropTypes,
} from '../../../../../pages/defaultProps';
import ResponsiveTwoRowLayout from '../../Layout/ResponsiveTwoRowLayout/ResponsiveTwoRowLayout';
import NavMenuItem from '../../Modules/NavbarItems/NavMenuItem/NavMenuItem';

import './UserNavbar.scss';
import userNavbarMenu from './userNavbarMenu';

export default class UserNavbar extends React.Component {
    static propTypes = {
        /**
         * Type of user's role
         */
        userRole: userRolePropTypes.isRequired,
        /**
         * Value of the view layout the page is in
         */
        pageDisplayMode: pageDisplayModePropTypes.isRequired,
        /**
         * new feed items, newJobs, pendingConnections
         */
        badgeCountData: PropTypes.object,
        /**
         * meta data for alerts icon
         */
        notifications: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        /**
         * whether user is logged in or not
         */
        isLoggedIn: PropTypes.bool,
        /**
         * data for user dropdown
         */
        userDropdownProps: PropTypes.object,
        /**
         * handler for setting Header's Action state
         */
        setActionState: PropTypes.func.isRequired,
        /**
         * handler for getting Header's Action state
         */
        getActionState: PropTypes.func.isRequired,
        /**
         * handler for emitting metrics
         */
        handleMetricEvent: PropTypes.func,
        /**
         * whether user is authorize for employer nav or not
         */
        athorizedForEmployerNav: PropTypes.bool,
        loginWidgetProps: PropTypes.object,
    };

    static defaultProps = {
        badgeCountData: {},
        loginWidgetProps: {},
        notifications: {},
        handleMetricEvent: () => {},
        getActionState: () => {},
        setActionState: () => {},
    };

    render() {
        const {
            getActionState,
            setActionState,
            athorizedForEmployerNav,
            badgeCountData,
            isLoggedIn,
            notifications,
            handleMetricEvent,
            userDropdownProps,
            featureFlags,
            loginWidgetProps,
        } = this.props;
        const { profileImage } = userDropdownProps;

        const {
            auth0,
            currentPath,
            redirectUri,
            invitationToken,
        } = loginWidgetProps;

        const loginModalProps = {
            auth0,
            loginRedirectPath: currentPath,
            redirectUri,
            invitationToken,
        };

        return (
            <ResponsiveTwoRowLayout className="component-Layout-Header-Navbars-UserNavbar">
                {({ viewWidth }) => (
                    <React.Fragment>
                        <ResponsiveTwoRowLayout.TopRow className="top-row">
                            {userNavbarMenu.map((menuItem, index) => (
                                <NavMenuItem
                                    key={`top-${index}`}
                                    navbarPosition="top"
                                    metaData={menuItem.metaData}
                                    Component={menuItem.Component}
                                    setActionState={setActionState}
                                    getActionState={getActionState}
                                    handleMetricEvent={handleMetricEvent}
                                    viewWidth={viewWidth}
                                    userDropdownProps={userDropdownProps}
                                    isLoggedIn={isLoggedIn}
                                    userImgSrc={profileImage}
                                    notifications={notifications}
                                    badgeCountData={badgeCountData}
                                    athorizedForEmployerNav={
                                        athorizedForEmployerNav
                                    }
                                    featureFlags={featureFlags}
                                    loginProps={loginModalProps}
                                />
                            ))}
                        </ResponsiveTwoRowLayout.TopRow>

                        <ResponsiveTwoRowLayout.BottomRow className="bottom-row">
                            {userNavbarMenu.map((menuItem, index) => (
                                <NavMenuItem
                                    key={`bottom-${index}`}
                                    navbarPosition="bottom"
                                    metaData={menuItem.metaData}
                                    Component={menuItem.Component}
                                    setActionState={setActionState}
                                    getActionState={getActionState}
                                    handleMetricEvent={handleMetricEvent}
                                    viewWidth={viewWidth}
                                    userDropdownProps={userDropdownProps}
                                    isLoggedIn={isLoggedIn}
                                    userImgSrc={profileImage}
                                    notifications={notifications}
                                    badgeCountData={badgeCountData}
                                    athorizedForEmployerNav={
                                        athorizedForEmployerNav
                                    }
                                    featureFlags={featureFlags}
                                    loginProps={loginModalProps}
                                />
                            ))}
                        </ResponsiveTwoRowLayout.BottomRow>
                    </React.Fragment>
                )}
            </ResponsiveTwoRowLayout>
        );
    }
}
